import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class ButtonShared {
  constructor() {}

  private dietTypeButtonClickObs = new BehaviorSubject<number>(-1);
  dietTypeButtonClickObs$ = this.dietTypeButtonClickObs.asObservable();

  private activityButtonClickObs = new BehaviorSubject<number>(-1);
  activityButtonClickObs$ = this.activityButtonClickObs.asObservable();

  private difficultyButtonClickObs = new BehaviorSubject<number>(-1);
  difficultyButtonClickObs$ = this.difficultyButtonClickObs.asObservable();

  dietTypeButtonClicked(id: number) {
    this.dietTypeButtonClickObs.next(id);
    this.dietTypeButtonClickObs.next(-1);
  }

  activityButtonClicked(id: number) {
    this.activityButtonClickObs.next(id);
    this.activityButtonClickObs.next(-1);
  }

  difficultyButtonClicked(id: number) {
    this.difficultyButtonClickObs.next(id);
    this.difficultyButtonClickObs.next(-1);
  }
}
